<template>
    <div class="flex">
        <div class="z-10">
            <div class="lg:hidden flex justify-between fixed items-center top-0 h-16 w-full z-40 pl-4 transition"
                 :class="mobileSidebarOpen ? 'bg-gray-900' : 'bg-gray-800'">
                <div class="flex items-center">
                    <span @click="toggleMobileSidebar">
                        <img alt="Storemanager" class="h-12 w-auto" src="../../../assets/images/Logo_AIW_dark.svg">
                    </span>
                    <span class="rounded px-2 py-1 text-xs ml-3 transition cursor-pointer"
                          :class="mobileSidebarOpen ? 'bg-gray-200 text-gray-700' : 'bg-gray-700 text-gray-400'"
                          @click="toggleMobileSidebar">
                        <template v-if="mobileSidebarOpen">
                            {{ $t('general.close_menu') }}
                        </template>
                        <template v-else>
                            {{ $t('general.open_menu') }}
                        </template>
                    </span>
                </div>
                <div>
                    <navigation-user-bar/>
                </div>
            </div>
            <!-- Off-canvas menu for mobile -->
            <transition
                @after-enter="mobileSidebarOpen = true"
                @before-leave="mobileSidebarOpen = false"
            >
                <div class="fixed inset-0 flex z-40 lg:hidden" v-if="mobileSidebar">
                    <transition
                        enter-active-class="transition-opacity ease-linear duration-300"
                        enter-class="opacity-0"
                        enter-to-class="opacity-100"
                        leave-active-class="transition-opacity ease-linear duration-300"
                        leave-class="opacity-100"
                        leave-to-class="opacity-0"
                    >
                        <div class="fixed inset-0 backdrop-filter backdrop-blur-sm" v-if="mobileSidebarOpen">
                            <div class="absolute inset-0 bg-gray-900 opacity-50" @click="toggleMobileSidebar"></div>
                        </div>
                    </transition>
                    <transition
                        @after-leave="mobileSidebar = false"
                        enter-active-class="transition ease-in-out duration-300 transform"
                        enter-class="-translate-x-full opacity-0"
                        enter-to-class="translate-x-0 opacity-100"
                        leave-active-class="transition ease-in-out duration-300 transform"
                        leave-class="translate-x-0 opacity-100"
                        leave-to-class="-translate-x-full opacity-0"
                    >
                        <div class="relative flex-1 flex flex-col max-w-xs w-full pb-4 bg-gray-800"
                             v-if="mobileSidebarOpen">
                            <div class="absolute top-0 right-0 -mr-14 p-1 mt-16">
                                <button
                                    class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                                    aria-label="Close sidebar" @click="toggleMobileSidebar">
                                    <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none"
                                         viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M6 18L18 6M6 6l12 12"/>
                                    </svg>
                                </button>
                            </div>
                            <navigation @closeMobile="toggleMobileSidebar"/>
                        </div>
                    </transition>
                    <div class="flex-shrink-0 w-14" v-if="mobileSidebarOpen">
                        <!-- Dummy element to force sidebar to shrink to fit close icon -->
                    </div>
                </div>
            </transition>
        </div>

        <!-- Static sidebar for desktop -->
        <div class="hidden lg:block lg:flex-shrink-0 w-64">
            <navigation/>
        </div>
    </div>
</template>

<script>
import Navigation from './Navigation';
import NavigationUserBar from './NavigationUserBar';

export default {
    components: {
        Navigation,
        NavigationUserBar,
    },

    data: () => ({
        appName: window.config.appName,
        mobileSidebar: false,
        mobileSidebarOpen: false,
    }),

    methods: {
        async logout() {
            // Log out the user.
            await this.$store.dispatch('auth/logout');

            // Redirect to login.
            this.$router.push({name: 'login'});
        },
        toggleMobileSidebar() {
            this.mobileSidebar ? (this.mobileSidebarOpen = false) : (this.mobileSidebar = !this.mobileSidebar);
        },
    },
};
</script>
